import { TTokenItem } from 'views/types/token';
import { TTotalAppVolumeResponse } from 'views/types/volume';
import { create, useStore } from 'zustand';

interface TokensStore {
  tokens: TTokenItem[];
  totalTokens: number;
  totalPages: number;
  totalItems: number;
  appVolumes: TTotalAppVolumeResponse | null;
}

export const tokensStore = create<TokensStore>((_set) => ({
  tokens: [],
  totalTokens: 0,
  totalPages: 0,
  totalItems: 0,
  appVolumes: null,
}));

export const useTokensStore = () => useStore(tokensStore);
